<template>
    <div class="page-channel page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">产品分类管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>产品管理</el-breadcrumb-item>
                            <el-breadcrumb-item>产品分类管理</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleChannel('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="name" label="产品分类名称：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.name" size="small" placeholder="产品分类名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="status" label="状态：">
                            <el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
                            <el-table-column prop="name" align="center" label="分类名称" min-width="120">
                            </el-table-column>
							<el-table-column prop="nav_name" align="center" label="关联导航" min-width="120">
							</el-table-column>
							<el-table-column prop="image_url" align="center" label="导航图片" min-width="120">
							    <template slot-scope="scope">
							        <img class="cursor" :src="baseUrl + scope.row.image_url" height="23" @click="dlg_preview.img_url = baseUrl + scope.row.image_url;dlg_preview.visible = true;" title="点击查看" />
							    </template>
							</el-table-column>
                            <el-table-column prop="sort" align="center" label="排序" min-width="120">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="200" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleChannel('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteChannel(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export channel-dialog" :title="dlg_group.title" :visible.sync="dlg_group.visible" width="534px" @closed="closeChannel" :close-on-click-modal="false">
            <el-form ref="formChannel" :model="dlg_group.form" label-width="110px" :rules="dlg_group.rules" @submit.native.prevent>
                <el-form-item prop="name" style="margin-top: 15px;" label="分类名称：" :error="dlg_group.error.name">
                    <el-input size="small" v-model="dlg_group.form.name" placeholder='请输入分类名称' clearable></el-input>
                </el-form-item>
				<el-form-item  prop="nav_id" label="关联导航：">
				    <el-select size="small" v-model="dlg_group.form.nav_id" placeholder="请选择" >
				        <el-option
				                v-for="item in dlg_group.init_data.nav_list"
				                :key="item.id"
				                :label="item.name"
				                :value="item.id">
				        </el-option>
				    </el-select>
				</el-form-item>
				<el-form-item prop="image_url" style="margin-top: 15px;" label="导航图：" :error="dlg_group.error.image_url">
				    <el-upload
				            :action="dlg_group.params.action"
				            :headers="dlg_group.params.headers"
				            :data="dlg_group.params.data"
				            accept="image/png,image/jpeg,image/jpg"
				            :class="dlg_group.hide_upload?'hide-upload head-upload':'head-upload'"
				            list-type="picture-card"
				            :file-list="dlg_group.img_list"
				            name="file"
				            :on-preview="(file) => {dlg_preview.img_url = file.url;dlg_preview.visible = true;}"
				            :on-remove="removeImg"
				            :on-success="uploadSuccessImg">
				        <i class="el-icon-plus"></i>
				    </el-upload>
				    <p class="img-tips">图片尺寸：450px*450px（请上传小于1M的图片）</p>
				</el-form-item>
                <el-form-item prop="sort" label="排序：">
                    <el-input size="small" type='number' v-model="dlg_group.form.sort" placeholder='请输入排序（输入数字）' clearable></el-input>
                </el-form-item>
                <el-form-item prop="status" label="状态：">
                    <el-radio-group v-model="dlg_group.form.status">
                        <el-radio v-for="(item, index) in dlg_group.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_group.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitChannel()" :loading="dlg_group.btn_loading">确认</el-button>
            </span>
        </el-dialog>
		<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
		    <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
		</el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
			var valiImg = (rule, value, callback) =>
			{
			    if (!this.dlg_group.hide_upload) {
			        callback(new Error("请上传导航图"));
			    } else {
			        callback();
			    }
			};
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
				baseUrl:this.$client.IMG_URL,
                //搜索
                form_search:{
                    name:"",
                    status: -1
                },
                init_data: {
                    status_list: [{id:-1, name: '全部'},{id:0, name: '禁用'},{id:1, name: '启用'}],
                },
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                dlg_group:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
					hide_upload: false,
					img_list: [],
                    form:{
                        name:'',
                        desk_number:'',
						nav_id:0,
						image_url:'',
                        sort:'',
                        status:1
                    },
                    error:{
                        name:''
                    },
                    reset_form: {},
                    init_data:{
                        status_list: [{id:0, name: '禁用'},{id:1, name: '启用'}],
                        nav_list:[],
                    },
                    rules:{
                        name:{required: true, message: '请输入分类名称', trigger: ['change','blur']},
                        type:{required: true, message: '请选择所属店铺', trigger: ['change','blur']},
						nav_id:{required: true, message: '请选择导航', trigger: ['change','blur']},
						image_url:{required: true, validator: valiImg},
                        sort:{required: true, message: '请输入排序（输入数字）', trigger: ['change','blur']},
                        status:{required: true, message: '请选择状态', trigger: ['change','blur']},
                    },
                    params:{
                        action: this.$client.API_URL+'/adminapi/upload/images',
                        data:{path:'banner'},
                        headers:{token:localStorage.getItem('token')}
                    }
                },
				dlg_preview:{
				    visible: false,
				    img_url: ''
				}
            }
        },
        created() {
            document.title = '产品分类管理';
            this.dlg_group.reset_form = Object.assign({}, this.dlg_group.form);
            this.getList();
            /*this.table_data.list = [
                {
                    id:1,
                    name:'新鲜水果',
                    type:1,
                    type_name:'推荐好物',
                    status:1,
                    sort:1,
                    status_name:'启用'
                },
                {
                    id:2,
                    name:'当日时蔬',
                    type:1,
                    type_name:'推荐好物',
                    status:0,
                    sort:1,
                    status_name:'禁用'
                },{
                    id:3,
                    name:'水产肉禽',
                    type:1,
                    type_name:'推荐好物',
                    sort:1,
                    status:1,
                    status_name:'启用'
                }
            ]*/
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/adminapi/deskproductgroup/joinlist', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.dlg_group.init_data.status_list = res.status_name_list;
                    _this.dlg_group.init_data.desk_list = res.desk_name_list;
					_this.dlg_group.init_data.nav_list = res.nav_name_list;
                    _this.init_data.status_list = status_list.concat(res.status_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
			uploadSuccessImg(res, file, fileList){
			    this.dlg_group.img_list = fileList;
			    this.dlg_group.form.image_url = res.data.file_url;
			    this.dlg_group.hide_upload = true;
			},
			removeImg(file, fileList){
			    this.dlg_group.form.image_url = '';
			    this.dlg_group.img_list = [];
			    this.dlg_group.hide_upload = false;
			},
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的产品分类");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/deskproductgroup/joindelete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },

            handleChannel(type,data){
                this.dlg_group.visible = true;
                if(type == 'add'){
                    this.dlg_group.title = '添加产品分类';
                    this.dlg_group.api = '/adminapi/deskproductgroup/joinsave';
                }else{
                    this.dlg_group.id= data.id;
                    this.dlg_group.title = '编辑产品分类';
                    if(data){
                        for(var key in this.dlg_group.form){
                            this.dlg_group.form[key] = data[key];
                        }
						if(data.image_url){
						    this.dlg_group.img_list = [{name: '导航图', url: this.baseUrl + data.image_url}];
						    this.dlg_group.hide_upload = true;
						}else{
						    this.dlg_group.img_list = [];
						    this.dlg_group.hide_upload = false;
						}
                    }
                    this.dlg_group.api = '/adminapi/deskproductgroup/joinsave?id=' + data.id;
                }
            },
            deleteChannel(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/deskproductgroup/joindelete', {id:id}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            submitChannel(){
                var _this = this;
                _this.$refs['formChannel'].validate((valid) => {
                    if (valid) {
                        this.dlg_group.btn_loading = true;
                        this.$client.post(this.dlg_group.api, this.dlg_group.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_group.btn_loading = false;
                            _this.dlg_group.visible = false;
                        }, function(message){
                            _this.dlg_group.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_group.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeChannel(){
                for(var key in this.dlg_group.form){
                    this.dlg_group.form[key] = this.dlg_group.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formChannel.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>

</style>
<style scoped>

</style>